// Veytan mobile app — store identifiers and URLs.
// App Store URL is region-agnostic (no /in/) so Apple auto-localizes.
// Play Store URL drops &hl=en_IN for the same reason.

export const APP_STORE_ID = '6743851627';
export const PLAY_STORE_PACKAGE = 'com.buzzworks.veytan';

export const APP_STORE_URL = `https://apps.apple.com/app/id${APP_STORE_ID}`;
export const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${PLAY_STORE_PACKAGE}`;
